import { ProfileService } from './../../../core/services/profile.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ProjectService } from './../../../core/services/project.service';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";
import { CommonModule } from '@angular/common';
import { validInvitationResponse } from '../../../core/models/project.model';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-layout',
  standalone:true,
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, ConfirmModalComponent, CommonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  isSidebarOpen = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService,
    private projectService: ProjectService,
    private profileService: ProfileService,
    private notificationService: NotificationService

  ) {}

  modalMessage!: string;
  isModalOpen!: boolean;
  uniqueKey!: string;
  loggedInUserEmail!: string


  async ngOnInit() {
    const uniqueKey = this.cookieService.get('uniqueKey');
    this.uniqueKey = uniqueKey

    try {
      const response = await firstValueFrom(this.profileService.getMyProfile());
      this.loggedInUserEmail = response.email;
    } catch (err) {
      console.log(err);
    }

    if (uniqueKey) {
      const payload: string = uniqueKey;

      this.projectService.validateControllerInvitation(payload).subscribe({
        next: (res: validInvitationResponse) => {
          if (this.loggedInUserEmail === res.email) {
            if (res.valid) {
              this.modalMessage = 'You have received an invitation. Do you want to accept it?';
              this.isModalOpen = true;
            }
          } else {
            this.notificationService.show('Logged In User is not valid.', 'error');
            this.cookieService.deleteAll();
            this.cookieService.delete('uniqueKey', '/');
          }
        },
        error: (err) => console.log('Validation failed:', err),
      });
    }
  }

  acceptControllerInvite(uniqueKey: string) {
    const payload = {uniqueKey};

    this.projectService.acceptControllerInvite(payload).subscribe({
      next: (res) => {
        this.cookieService.delete('uniqueKey', '/controllers');
        this.closeModal();
        this.router.navigate(['/controllers'])

      },
      error: (err) => {
        console.error('Accept failed:', err);
        this.closeModal();
      }
    });
  }


  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeModal() {
    this.isModalOpen = false;
  }

}
